<template>
    <div class="contents">
        <div class="container-fluid">
            <FollowUpNavigation />
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    Riwayat Follow Up Kontak
                                </h4>
                            </div>
                        </div>
                        <div class="mb-3">
                            <button 
                                type="button" 
                                @click="toggleModal('addContactFollowUp')" 
                                class="btn btn-primary"
                            >
                                <i class="fas fa-plus"></i> Tambah Kontak & Follow Up Manual
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <FollowUpContactHistoryTable ref="historyTable" />
                    </div>
                </div>
            </div>
        </div>
        <modal name="addContactFollowUp" :height="'auto'" :adaptive="true" :scrollable="true">
            <div style="margin: 20px">
                <center>
                    <h2>Tambah Kontak & Follow Up Manual</h2>
                </center>
                <br>
                <div class="form-group">
                    <label>Tipe Kontak</label>
                    <select v-model="contactMode" class="form-control" @change="onContactModeChange">
                        <option value="new">Kontak Baru</option>
                        <option value="existing">Kontak Existing</option>
                    </select>
                </div>
                <br>
                <form @submit.prevent="addContactAndFollowUp">
                    <!-- Kontak Existing -->
                    <div v-if="contactMode === 'existing'">
                        <div class="form-group">
                            <label>Pilih Kontak <span class="text-danger">*</span></label>
                            <multiselect 
                                v-model="selectedContact" 
                                tag-placeholder="Cari kontak"
                                placeholder="Cari kontak" 
                                label="label" 
                                track-by="id" 
                                :options="contactOptions"
                                :multiple="false" 
                                :internal-search="false" 
                                :loading="isLoadingContacts"
                                @search-change="loadContacts"
                            />
                            <small class="form-text text-muted">Cari dan pilih kontak dari database</small>
                        </div>
                    </div>
                    
                    <!-- Kontak Baru -->
                    <div v-else>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Nama Kontak <span class="text-danger">*</span></label>
                                    <input 
                                        type="text" 
                                        v-model="form.name" 
                                        class="form-control" 
                                        required
                                        placeholder="Nama kontak"
                                    />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Nomor WhatsApp <span class="text-danger">*</span></label>
                                    <input 
                                        type="text" 
                                        v-model="form.number" 
                                        class="form-control" 
                                        required
                                        placeholder="6281234567890"
                                    />
                                    <small class="form-text text-muted">Format: 6281234567890 (tanpa +)</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="form-group">
                        <label>Pilih Follow Up <span class="text-danger">*</span></label>
                        <select 
                            v-model="form.follow_up_id" 
                            class="form-control" 
                            required
                        >
                            <option value="">Pilih Follow Up</option>
                            <option 
                                v-for="followUp in followUps" 
                                :key="followUp.id" 
                                :value="followUp.id"
                            >
                                {{ followUp.name }} ({{ followUp.is_active ? 'Aktif' : 'Nonaktif' }})
                            </option>
                        </select>
                        <small class="form-text text-muted">Pilih follow up yang akan dijalankan untuk kontak ini</small>
                    </div>
                    <div class="form-group">
                        <button 
                            type="submit" 
                            class="btn btn-success btn-block"
                            :disabled="isSubmitting"
                        >
                            <i class="fas fa-save"></i> 
                            {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                        </button>
                    </div>
                </form>
            </div>
        </modal>
    </div>
</template>

<script>
import FollowUpContactHistoryTable from "@/components/tables/FollowUpContactHistory.vue";
import FollowUpNavigation from "@/components/followup/Navigation.vue";
import Multiselect from 'vue-multiselect';

export default {
    components: {
        FollowUpContactHistoryTable,
        FollowUpNavigation,
        Multiselect
    },
    data() {
        return {
            contactMode: 'existing',
            selectedContact: null,
            contactOptions: [],
            isLoadingContacts: false,
            isSubmitting: false,
            followUps: [],
            form: {
                name: '',
                number: '',
                follow_up_id: '',
                variable: {
                    produk: '',
                    harga: ''
                }
            }
        };
    },
    async mounted() {
        await this.loadFollowUps();
        this.$nextTick(() => {
            if (this.$refs.historyTable) {
                this.$refs.historyTable.loadItems();
            }
        });
    },
    methods: {
        async toggleModal(param) {
            this.$modal.toggle(param);
            if (param === 'addContactFollowUp') {
                this.resetForm();
                // Load initial contacts if mode is existing
                if (this.contactMode === 'existing') {
                    await this.loadContacts('');
                }
            }
        },
        resetForm() {
            this.contactMode = 'new';
            this.selectedContact = null;
            this.contactOptions = [];
            this.form = {
                name: '',
                number: '',
                follow_up_id: '',
                variable: {
                    produk: '',
                    harga: ''
                }
            };
        },
        async onContactModeChange() {
            this.selectedContact = null;
            this.form.name = '';
            this.form.number = '';
            this.form.variable.produk = '';
            this.form.variable.harga = '';
            
            // Load initial contacts if switching to existing mode
            if (this.contactMode === 'existing') {
                await this.loadContacts('');
            } else {
                this.contactOptions = [];
            }
        },
        async loadContacts(query) {
            this.isLoadingContacts = true;
            try {
                const params = {
                    page: 1,
                    limit: 50
                };
                
                // Add search filter if query provided
                if (query && query.length > 0) {
                    params.columnFilters = JSON.stringify({
                        name: query
                    });
                }
                
                const response = await this.$store.dispatch("contact_list", params);
                
                const contacts = response.data.data.contacts || [];
                this.contactOptions = contacts.map(contact => ({
                    id: contact.id,
                    label: `${contact.name} (${contact.number})`,
                    name: contact.name,
                    number: contact.number,
                    data: contact.data
                }));
            } catch (err) {
                this.$toast.error("Gagal memuat kontak");
            } finally {
                this.isLoadingContacts = false;
            }
        },
        async loadFollowUps() {
            try {
                const response = await this.$store.dispatch("followup/followup_list", {
                    page: 1,
                    limit: 100
                });
                this.followUps = response.data.data.follow_ups || [];
            } catch (err) {
                this.$toast.error("Gagal memuat daftar follow up");
            }
        },
        async addContactAndFollowUp() {
            if (!this.form.follow_up_id) {
                this.$toast.error("Follow up wajib dipilih");
                return;
            }

            if (this.contactMode === 'existing') {
                if (!this.selectedContact) {
                    this.$toast.error("Kontak wajib dipilih");
                    return;
                }
            } else {
                if (!this.form.name || !this.form.number) {
                    this.$toast.error("Nama dan nomor kontak wajib diisi");
                    return;
                }
            }

            this.isSubmitting = true;
            try {
                let contactId = null;

                if (this.contactMode === 'existing') {
                    // Use existing contact
                    contactId = this.selectedContact.id;
                } else {
                    // Create new contact
                    const variableData = [];
                    if (this.form.variable.produk) {
                        variableData.push({ id: 1, value: this.form.variable.produk });
                    }
                    if (this.form.variable.harga) {
                        variableData.push({ id: 2, value: this.form.variable.harga });
                    }

                    const contactData = {
                        name: this.form.name,
                        number: this.form.number,
                        variable: variableData.length > 0 ? variableData : null
                    };

                    await this.$store.dispatch("contact_create", contactData);

                    // Find contact by number to get contact_id
                    const contactListResponse = await this.$store.dispatch("contact_list", {
                        page: 1,
                        limit: 1,
                        columnFilters: JSON.stringify({
                            number: this.form.number
                        })
                    });

                    if (contactListResponse.data.data.contacts && contactListResponse.data.data.contacts.length > 0) {
                        contactId = contactListResponse.data.data.contacts[0].id;
                    } else {
                        throw new Error("Kontak tidak ditemukan setelah dibuat");
                    }
                }

                // Trigger follow up manually
                await this.$store.dispatch("followup/followup_trigger_manual", {
                    contact_id: contactId,
                    follow_up_id: parseInt(this.form.follow_up_id)
                });

                this.$toast.success("Kontak dan follow up berhasil ditambahkan");
                this.resetForm();
                this.toggleModal('addContactFollowUp');
                this.$refs.historyTable.loadItems();
            } catch (err) {
                this.$toast.error(err.response?.data?.message || err.message || "Gagal menambahkan kontak dan follow up");
            } finally {
                this.isSubmitting = false;
            }
        }
    }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


